import { getApiUrl, getAxiosInstanceByLoginMode } from './shared';

const getEmployeeDistricts = () => {
  return getAxiosInstanceByLoginMode().get(`${getApiUrl()}/districts`);
};

export { getEmployeeDistricts };
